import { CheckCircleOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { Button, Flex, Tag, Tooltip, Typography } from 'antd';

import placeholderImage from '@/lib/assets/placeholder.jpg';
import getPlatformFromUrl from '@/lib/helpers/getPlatformFromTabUrl';
import { prepareDateHistory } from '@/lib/helpers/prepareDate';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';
import { IMonitorCreatorItem, IVideoCollectionItem } from '@/ts';

import styles from './styles.module.css';

import Platforms from '../../../creators/platforms';

const creatorsCollectionsColumns = [
	// {
	//   title: "Title / Description",
	//   dataIndex: "title",
	//   key: "title",
	//   // sorter: false,
	//   ellipsis: true,
	//   width: 90,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return (
	//       <Tooltip title={record?.title}>
	//         <Flex vertical>
	//           <span>{record?.title}</span>
	//           <span style={{ color: "gray" }}>{record?.description}</span>
	//         </Flex>
	//       </Tooltip>
	//     );
	//   },
	// },
	// {
	//   title: "Description",
	//   dataIndex: "description",
	//   key: "description",
	//   // sorter: true,
	//   ellipsis: true,
	//   width: 80,
	//   flex: true,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return (
	//       <Tooltip title={record?.description}>{record?.description}</Tooltip>
	//     );
	//   },
	// },
	{
		title: 'Creators',
		dataIndex: 'creatorsAmount',
		key: 'creatorsAmount',
		// sorter: false,
		ellipsis: true,
		width: 35,
		render: (_: any, record: IVideoCollectionItem) => {
			return (
				<Flex align="center" justify="center" style={{ width: '100%' }}>
					{record?.items_count || 0}
				</Flex>
			);
		},
	},
	{
		title: 'Date',
		ellipsis: true,
		width: 55,
		sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'created_at',
		key: 'created_at',
		render: (_: any, record: IVideoCollectionItem) => {
			return record?.created_at
				? prepareDateHistory(record?.created_at?.toString())
				: null;
		},
	},
];

const addRemovecreatorsCollectionsColumns = [
	{
		title: 'Title',
		dataIndex: 'title',
		key: 'title',
		// sorter: false,
		ellipsis: true,
		width: 90,
		render: (_: any, record: IVideoCollectionItem) => {
			return <Tooltip title={record?.title}>{record?.title}</Tooltip>;
		},
	},
	{
		title: 'Creators amount',
		dataIndex: 'creatorsAmount',
		key: 'creatorsAmount',
		// sorter: false,
		ellipsis: true,
		width: 60,
		render: (_: any, record: IVideoCollectionItem) => {
			return (
				<Flex align="center" justify="center" style={{ width: '100%' }}>
					{record?.items_count || 0}
				</Flex>
			);
		},
	},
	{
		title: 'Date',
		ellipsis: true,
		width: 50,
		sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'created_at',
		key: 'created_at',
		render: (_: any, record: IVideoCollectionItem) => {
			return record?.created_at
				? prepareDateHistory(record?.created_at?.toString())
				: null;
		},
	},
];

const singleCollectionCreatorsColumns = [
	{
		title: 'Creator',
		dataIndex: 'title',
		key: 'title',
		// sorter: false,
		ellipsis: true,
		width: 150,
		render: (_: any, record: IMonitorCreatorItem) => {
			const platform = getPlatformFromUrl(record?.url);

			return (
				<Flex gap={4} align="center">
					{record?.profile_image_url ? (
						<img
							src={
								record?.profile_image_url?.startsWith('http')
									? record?.profile_image_url
									: prepareImageSrc(record?.profile_image_url)
							}
							alt={record?.profile_name}
							className={styles.thumbnail}
							width={36}
							height={36}
							onError={(e) => {
								// @ts-ignore
								e.target.src = placeholderImage; // Fallback image
							}}
						/>
					) : (
						<img
							src={placeholderImage}
							width={130}
							height={124}
							className={styles.thumbnail}
						/>
					)}
					{record?.platform_handles?.length > 0 ? (
						<Tooltip title={record?.profile_name}>
							<Button
								type="link"
								size="large"
								href={
									record?.platform_handles?.[1] || record?.platform_handles?.[0]
								}
								target="_blank"
								style={{
									width: 'fit-content',
									fontSize: '14px',
									display: 'flex',
									wordWrap: 'break-word',
									overflow: 'hidden',
									padding: '2px',
								}}
							>
								<span
									style={{
										width: '100%',
										fontSize: '14px',
										display: 'inline-block',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{record?.profile_name}
								</span>
							</Button>
						</Tooltip>
					) : (
						<Tooltip title={record?.profile_name}>
							<Typography.Text
								style={{
									width: 'fit-content',
									fontSize: '14px',
									display: 'inline-block',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{record?.profile_name}
							</Typography.Text>
						</Tooltip>
					)}

					{platform?.name && (
						<Tooltip title={platform?.name}>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<Platforms platform={platform?.id!} />
							</div>
						</Tooltip>
					)}
				</Flex>
			);
		},
	},
	{
		title: 'Search tags',
		dataIndex: 'tags',
		key: 'tags',
		ellipsis: true,
		width: 100,
		render: (_: any, record: IMonitorCreatorItem) => {
			return (
				<Flex align="center">
					{record?.tags?.map((keyword: string, index: number) => (
						<Tag key={index}>{keyword}</Tag>
					))}
				</Flex>
			);
		},
	},
];

const mockCreatorsCollectionsItems = [
	{
		id: 1,
		name: 'USA Airlines influencers',
		description: 'Collection of influencers who promote USA Airlines',
		// active: true,
		creatorsAmount: 2,
		createdAt: '2025-01-10 11:46:51.930 +0200',
		updatedAt: '2025-01-10 11:46:51.930 +0200',
	},
	{
		id: 2,
		name: 'British travel bloggers',
		description: 'Collection of British travel bloggers',
		// active: true,
		creatorsAmount: 3,
		createdAt: '2025-02-08 15:46:51.930 +0200',
		updatedAt: '2025-02-08 15:46:51.930 +0200',
	},
];

const mockCreatorsItems = [
	{
		id: '1',
		url: 'https://www.instagram.com/willsmith/',
		profileImageURL:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOxO3Xx6C1IjcL6VPRvNwRO6CfvajSQnV2Sw&s',
		profileName: 'Top airlines',
		createdAt: '2024-09-27 15:46:51.930 +0200',
		keywords: ['airlines'],
	},

	{
		id: '2',
		url: 'https://www.youtube.com/@BBCNews',
		profileImageURL:
			'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEajDtAyPNVUK2RV5pWBlNrNVUaWU3BMj2Cw&s',
		profileName: 'Fly with me',
		created_at: '2024-09-25 15:46:51.930 +0200',
		keywords: ['pilot', 'airports'],
	},
];

export {
	creatorsCollectionsColumns,
	addRemovecreatorsCollectionsColumns,
	singleCollectionCreatorsColumns,
	mockCreatorsItems,
	mockCreatorsCollectionsItems,
};
